/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_View_ToggleInputs */

const cs_gallery_view_toggle = /** @type {(inputs: Gallery_View_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozložení galerie`)
};

const en_gallery_view_toggle = /** @type {(inputs: Gallery_View_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gallery layout`)
};

/**
* | output |
* | --- |
* | "Gallery layout" |
*
* @param {Gallery_View_ToggleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_view_toggle = /** @type {((inputs?: Gallery_View_ToggleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_View_ToggleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_view_toggle(inputs)
	return cs_gallery_view_toggle(inputs)
});